import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

// آدرس تصاویر پرچم
import irFlag from "./Flag_of_Iran.svg";
import usFlag from "./Flag_of_the_United_States.svg";
import { ArrowDown } from "lucide-react";
import { ArrowDown2 } from "iconsax-react";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const currentLanguage = i18n.language.includes("fa") ? "FA - فارسی" : "English - EN";
  const currentFlag = i18n.language.includes("fa") ? irFlag : usFlag;

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        className="flex items-center bg-white text-[14px] border border-gray-300 rounded-full px-4 py-2 text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors duration-200"
        onClick={toggleDropdown}
      >
        <img src={currentFlag} alt="Current Flag" className="w-6 h-auto me-2" />
        <span>{currentLanguage}</span>
        <ArrowDown2/>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 z-10 mt-2 w-40 bg-white border border-gray-300 rounded-md shadow-lg">
          <button
            className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100 transition-colors duration-200"
            onClick={() => changeLanguage("fa")}
          >
            <img src={irFlag} alt="Iranian Flag" className="w-6 h-auto mr-3" />
            فارسی
          </button>
          <button
            className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100 transition-colors duration-200"
            onClick={() => changeLanguage("en")}
          >
            <img src={usFlag} alt="American Flag" className="w-6 h-auto mr-3" />
            English
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
